<template>
<q-expansion-item
    expand-separator
    header-class="text-primary"
    :group="group"
>
  <template v-slot:header>
    <q-item-section class="text-primary text-weight-bold">
      {{ object.title }}
      <q-item-label caption>
        {{ object.type }}
      </q-item-label>
    </q-item-section>
  </template>
  <q-card>
    <q-card-section>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="row q-mb-md">
            <div class="col-xs-12 col-lg-3 text-weight-bold">
              Type:
            </div>
            <div class="col-xs-12 col-lg-9">
              {{ object.type ? object.type : '-' }}
            </div>
          </div>
          <div class="row q-mb-md">
            <div class="col-xs-12 col-lg-3 text-weight-bold">
              Kleur:
            </div>
            <div class="col-xs-12 col-lg-9">
              {{ object.color ? object.color : '-' }}
            </div>
          </div>
          <div class="row q-mb-md">
            <div class="col-xs-12 col-lg-3 text-weight-bold">
              Specificaties:
            </div>
            <div class="col-xs-12 col-lg-9">
              {{ object.dimensions ? object.dimensions : '-' }}
            </div>
          </div>
          <div class="row q-mb-md">
            <div class="col-xs-12 col-lg-3 text-weight-bold">
              Materiaal:
            </div>
            <div class="col-xs-12 col-lg-9">
              {{ object.material ? object.material : '-' }}
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row q-mb-md">
            <div class="col-xs-12 col-lg-3 text-weight-bold">
              Mogelijke leveranciers:
            </div>
            <div class="col-xs-12 col-lg-9">
              {{ object.supplier ? object.supplier : '-' }}
            </div>
          </div>
          <div class="row q-mb-md">
            <div class="col-xs-12 col-lg-3 text-weight-bold">
              Subcategorie:
            </div>
            <div class="col-xs-12 col-lg-9">
              {{ group.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="row q-mb-md">
        <div class="col-xs-12 col-lg-3 text-weight-bold">
          Uitvoerings&shy;voorschriften:
        </div>
        <div class="col-xs-12 col-lg-9">
          {{ object.requirements ? object.requirements : '-' }}
        </div>
      </div>
      <div v-if="contentOwners.length" class="row q-mb-md">
        <div class="col-xs-12 col-lg-3 text-weight-bold">
          <span v-if="contentOwners.length === 1">Contenteigenaar/eigenaren</span>
          <span v-else>Contenteigenaren</span>
        </div>
        <div class="col-xs-12 col-lg-9">
          {{ contentOwners.join(', ') }}
        </div>
      </div>
    </q-card-section>
    <q-card-section v-if="object.assets.length">
      <h5>Documenten</h5>
      <document-list
          :documents="object.assets" />
    </q-card-section>
  </q-card>
</q-expansion-item>

</template>

<script>
import DocumentList from '../../../components/lists/DocumentList.vue'

export default {
  components: { DocumentList },
  props: {
    object: {
      type: Object,
      required: true,
    },
    group: {
      type: String,
      required: true,
    },
  },

  computed: {
    contentOwners () {
      return this.object.categories.reduce((owners, category) => {
        if (category.content_owner && owners.includes(category.content_owner) === false) {
          owners.push(category.content_owner)
        }
        return owners
      }, [])
    },
  },
}
</script>
